// JustValidate plugin: RequiredIf
// ===============================

class JustValidatePluginRequiredIf {
    constructor(validation, field) {
        this.validation = validation;
        this.fieldSelector = `#${field.id}`;
        this.conditionalField = field.form[field.dataset.valRequiredifName];
        this.conditionalValue = field.dataset.valRequiredifValue;

        switch (this.conditionalField.constructor.name) {
            case 'RadioNodeList':
                this.conditionalField.forEach((element) => {
                    this.initCoditionalField(element);
                });
                break;
            default:
                this.initCoditionalField(this.conditionalField);
        }
    }

    static getFieldValue(field) {
        switch (field.type) {
            case 'checkbox':
                return (field.checked) ? 'true' : 'false';
            default:
                return field.value;
        }
    }

    initCoditionalField(conditionalField) {
        if (conditionalField.value !== undefined) {
            conditionalField.addEventListener('change', () => {
                if (this.validation.isSubmitted) {
                    this.validation.revalidateField(this.fieldSelector);
                }
            });
        }
    }

    validate(value) {
        return (JustValidatePluginRequiredIf.getFieldValue(this.conditionalField) !== this.conditionalValue) || (value !== '' && value !== undefined && value !== false);
    }
}

export default JustValidatePluginRequiredIf;
